/**
 * Formats currency values as Israeli Shekel (ILS)
 */
export function formatCurrency(amount: number | undefined | null, currency: string = 'ILS'): string {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '₪0.00'
  }
  
  return new Intl.NumberFormat('he-IL', {
    style: 'currency',
    currency: currency,
  }).format(amount)
}

/**
 * Formats currency value for input fields (just the symbol)
 */
export function getCurrencySymbol(currency: string = 'ILS'): string {
  try {
    const part = new Intl.NumberFormat('he-IL', {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
    })
      .formatToParts(0)
      .find((p) => p.type === 'currency')
    return part?.value ?? '₪'
  } catch {
    return '₪'
  }
}

